import { jsx as o } from "react/jsx-runtime";
import { S as w } from "./chunks/index.CCavb-1K.js";
import { c as A } from "./chunks/index.rKuIKazb.js";
import i from "react";
import { Flex as x } from "./flex.js";
import { j as P, r as R, L as k } from "./chunks/layout.BROMuy9M.js";
import { Text as u } from "./text.js";
import { c as z } from "./chunks/create-context.DwEJDSIV.js";
import { Icon as L } from "./icon.js";
import { Spinner as f } from "./spinner.js";
import { u as F, A as O } from "./chunks/as-child-context.ihEwNgkv.js";
import { B as b } from "./chunks/JOBHIYEN.DiBKvV5J.js";
import './assets/button.css';const [T, h] = z({
  rootComponentName: "Button"
}), g = i.forwardRef((m, _) => {
  const s = h(), { loading: e, icon: n, mode: d, ...r } = { ...s, ...m };
  return e ? /* @__PURE__ */ o(f, { size: "md" }) : /* @__PURE__ */ o(L, { icon: n, mode: d, ref: _, ...r });
});
g.displayName = "Button.Icon";
const y = i.forwardRef((m, _) => {
  const s = h(), { loading: e } = { ...s, ...m };
  return /* @__PURE__ */ o(f, { size: "md", loading: e, ref: _ });
});
y.displayName = "Button.Spinner";
const V = "_button_pu6jo_3", $ = "_label_pu6jo_28", q = "_primary_pu6jo_328", D = "_disabled_pu6jo_338", E = "_secondary_pu6jo_344", G = "_ghost_pu6jo_345", H = "_accent_pu6jo_377", J = "_brabus_pu6jo_393", K = "_glass_pu6jo_409", M = "_inverted_pu6jo_427", t = {
  button: V,
  "mode-200": "_mode-200_pu6jo_16",
  "mode-300": "_mode-300_pu6jo_20",
  "mode-400": "_mode-400_pu6jo_24",
  label: $,
  "icon-button": "_icon-button_pu6jo_32",
  "mode-100": "_mode-100_pu6jo_32",
  "mode-100-xs": "_mode-100-xs_pu6jo_39",
  "mode-100-sm": "_mode-100-sm_pu6jo_47",
  "mode-100-md": "_mode-100-md_pu6jo_55",
  "mode-100-lg": "_mode-100-lg_pu6jo_63",
  "mode-100-xl": "_mode-100-xl_pu6jo_71",
  "mode-100-xxl": "_mode-100-xxl_pu6jo_79",
  "mode-200-xs": "_mode-200-xs_pu6jo_93",
  "mode-200-sm": "_mode-200-sm_pu6jo_101",
  "mode-200-md": "_mode-200-md_pu6jo_109",
  "mode-200-lg": "_mode-200-lg_pu6jo_117",
  "mode-200-xl": "_mode-200-xl_pu6jo_125",
  "mode-200-xxl": "_mode-200-xxl_pu6jo_133",
  "mode-300-xs": "_mode-300-xs_pu6jo_147",
  "mode-300-sm": "_mode-300-sm_pu6jo_155",
  "mode-300-md": "_mode-300-md_pu6jo_163",
  "mode-300-lg": "_mode-300-lg_pu6jo_171",
  "mode-300-xl": "_mode-300-xl_pu6jo_179",
  "mode-300-xxl": "_mode-300-xxl_pu6jo_187",
  "mode-400-xs": "_mode-400-xs_pu6jo_201",
  "mode-400-sm": "_mode-400-sm_pu6jo_209",
  "mode-400-md": "_mode-400-md_pu6jo_217",
  "mode-400-lg": "_mode-400-lg_pu6jo_225",
  "mode-400-xl": "_mode-400-xl_pu6jo_233",
  "mode-400-xxl": "_mode-400-xxl_pu6jo_241",
  "text-button": "_text-button_pu6jo_248",
  primary: q,
  disabled: D,
  secondary: E,
  ghost: G,
  accent: H,
  brabus: J,
  glass: K,
  inverted: M
}, no = [
  "primary",
  "secondary",
  "ghost",
  "accent",
  "brabus",
  "glass",
  "inverted"
], ro = ["text", "icon"], C = i.forwardRef(
  ({
    variant: m = "primary",
    buttonType: _ = "text",
    mode: s = 200,
    loading: e,
    disabled: n,
    children: d,
    width: r,
    height: B,
    display: v,
    padding: N,
    margin: I,
    asChild: l,
    className: c,
    ...a
  }, p) => {
    const { hasAsChildParent: S } = F(), j = A(
      t.button,
      t[m],
      P(R("mode", s), t),
      {
        [t.disabled]: e || n,
        [t["icon-button"]]: _ === "icon",
        [t["text-button"]]: _ === "text"
      },
      c
    );
    return /* @__PURE__ */ o(T, { loading: e, mode: s, children: /* @__PURE__ */ o(O, { hasAsChildParent: l, children: S ? /* @__PURE__ */ o(
      b,
      {
        ref: p,
        disabled: n || e,
        className: c,
        ...a,
        children: d
      }
    ) : /* @__PURE__ */ o(u, { className: t.label, variant: "link-100", asChild: !0, children: /* @__PURE__ */ o(
      k,
      {
        width: r,
        height: B,
        display: v,
        padding: N,
        margin: I,
        asChild: !0,
        children: l ? /* @__PURE__ */ o(u, { variant: "link-100", asChild: !0, children: /* @__PURE__ */ o(
          x,
          {
            justifyContent: "center",
            alignItems: "center",
            gap: 50,
            width: "fit-content",
            asChild: !0,
            children: /* @__PURE__ */ o(w, { className: j, ...a, children: d })
          }
        ) }) : /* @__PURE__ */ o(
          b,
          {
            ref: p,
            disabled: n || e,
            className: j,
            ...a,
            children: /* @__PURE__ */ o(u, { variant: "link-100", asChild: !0, children: /* @__PURE__ */ o(
              x,
              {
                justifyContent: "center",
                alignItems: "center",
                gap: 50,
                width: "full",
                children: d
              }
            ) })
          }
        )
      }
    ) }) }) });
  }
), ao = Object.assign(C, {
  Icon: g,
  Spinner: y
});
C.displayName = "Button";
export {
  ao as Button,
  ro as buttonTypes,
  no as buttonVariants
};
//# sourceMappingURL=button.js.map
